import type { NormalizedCacheObject } from '@apollo/client';

declare global {
    interface Window {
        __APOLLO_STATE__?: NormalizedCacheObject;
    }
}

export function getInitialApolloState(
    shouldHydrate: boolean = true,
): NormalizedCacheObject | undefined {
    if (typeof window === 'undefined') return undefined;

    if (!shouldHydrate) return undefined;

    return window.__APOLLO_STATE__;
}
